/**
 * Single validated env-config module (React_Web_Standards §8.1). Every
 * import.meta.env read lives here — do not sprinkle VITE_* access through
 * the codebase. Reminder: everything VITE_* is public and visible in the
 * bundle; secrets never belong here.
 *
 * Reads are written out one by one on purpose: Vite replaces
 * `import.meta.env.VITE_NAME` statically, so a dynamic lookup would come back
 * undefined in a production build.
 *
 * Which values are required, and why, is recorded in StagehandUI/CLAUDE.md
 * § Auth. The list itself lives in ./envRules, which vite.config.ts also runs
 * at build time; this check stays as the backstop for dev and tests.
 */

import { findInvalidEnv, missingEnvMessage } from './envRules'

const raw = {
  VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
  VITE_ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT,
  VITE_IS_LOCAL: import.meta.env.VITE_IS_LOCAL,
  VITE_MSAL_CLIENT_ID: import.meta.env.VITE_MSAL_CLIENT_ID,
  VITE_MSAL_AUTHORITY_BASE: import.meta.env.VITE_MSAL_AUTHORITY_BASE,
  VITE_MSAL_TENANT_ID: import.meta.env.VITE_MSAL_TENANT_ID,
  VITE_MSAL_REDIRECT_URL: import.meta.env.VITE_MSAL_REDIRECT_URL,
  VITE_API_SCOPE_API_ACCESS: import.meta.env.VITE_API_SCOPE_API_ACCESS,
} satisfies Record<string, string | undefined>

const invalid = findInvalidEnv(raw)

if (invalid.length > 0) {
  throw new Error(missingEnvMessage(invalid))
}

export const env = {
  /** Blank outside deployed builds, so the Vite proxy handles /api/*. */
  apiBaseUrl: raw.VITE_API_BASE_URL as string,
  /** Markers only — nothing reads these two yet. */
  environment: raw.VITE_ENVIRONMENT ?? 'LOCAL',
  isLocal: (raw.VITE_IS_LOCAL ?? 'true') === 'true',
  isDev: import.meta.env.DEV,
} as const

/** Validated above, so every field is a real value by the time it is read. */
export const msalEnv = {
  clientId: raw.VITE_MSAL_CLIENT_ID as string,
  authorityBase: raw.VITE_MSAL_AUTHORITY_BASE as string,
  tenantId: raw.VITE_MSAL_TENANT_ID as string,
  redirectUrl: raw.VITE_MSAL_REDIRECT_URL as string,
  apiScope: raw.VITE_API_SCOPE_API_ACCESS as string,
} as const
